import { createContext } from 'react';
import { TeamContextData } from './interfaces/team-context-props.interface';

export const TeamContext = createContext<TeamContextData>(
    {} as TeamContextData,
);
